import Form from 'react-bootstrap/Form';
import { Field } from 'formik';

let ValidationCheckbox = ({ name, label, ...props }) => {
  return (
    <Field name={name}>
      {({ field }) => {
        return (
          <Form.Check
            {...props}
            className="mb-3"
            id={`check-${name}`}
            name={name}
            label={label}
            {...field}
            checked={field.value}
            data-cy={`input-${name}`}
          />
        );
      }}
    </Field>
  );
};

export default ValidationCheckbox;
